export const GET_CLIENT_CONFIG = 'GetClientConfig';
export const GET_CLIENT_LOCATIONS = 'GetClientLocations';
export const GET_SIGNED_SIGMA_EMBEDS = 'GetSignedSigmaEmbeds';
